import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import DialogServices from '../../../services/dialog.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../../services/angular-broadcast-helper.service';
import RoutingService from '../../../services/routing.service';
import IdCodeUtil from '../../../utils/id-code-util.service';
import { ModalInsertForPersonGiveConsentsComponent } from '../../../components/pre-visit/insert-for-person/modal-give-consents/modal-give-consents.component';
import { ModalInsertForPersonCreateUserComponent } from '../../../components/pre-visit/insert-for-person/modal-create-user/modal-create-user.component';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'pre-visit-insert-for-person',
	templateUrl: './pre-visit-insert-for-person.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export default class PreVisitInsertForPersonComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private idCodeUtil: IdCodeUtil = inject(IdCodeUtil);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onResolve() {
		this.vm.userEstonianIdentificationCode = "";
		this.vm.isValidatePatientStep1 = true;
		this.vm.isValidatePatientStep2 = false;
		this.vm.showCreateUserButton = false;
		this.vm.showIdentifierDoesNotValidate = false;
		this.vm.isUserConsentsNotGiven = false;
		this.vm.isInsuranceDataNotFound = false;
		this.vm.isInserterAndPatientNotServicedBySameGpOrganization = false;
		this.vm.loading = false;
		this.vm.requesterRelationshipToPatient = "";
		
		this.preVisitRecordTicketForPersonService.clearData();
		this.preVisitRecordTicketForPersonService.setRequestRecorder(this.session.getSession());
		this.preVisitRecordTicketForPersonService.setRequester(this.session.getSession());
		
		this.vm.validatePatientIdentifier = this.validatePatientIdentifier;
		this.vm.searchUserByIdCode = this.searchUserByIdCode;
		this.vm.cantUseServiceReasonPicker = this.cantUseServiceReasonPicker;
		this.vm.showCreateUserModal = this.showCreateUserModal;
		this.vm.showGiveConsentsModel = this.showGiveConsentsModel;
		
		// TODO ANGULAR_2: fix $routeChangeStart
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, '$routeChangeStart',
				($event, next, current) => {
					if (!this.preVisitRecordTicketForPersonService.getPatient()
						|| !this.preVisitRecordTicketForPersonService.getRequesterRelationshipToPatient()) {
						this.preVisitRecordTicketForPersonService.clearData();
					}
				})
		);
	}
	
	validatePatientIdentifier() {
		this.vm.showIdentifierDoesNotValidate = false;
		this.vm.isUserConsentsNotGiven = false;
		this.vm.isInserterAndPatientNotServicedBySameGpOrganization = false;
		this.vm.userEstonianIdentificationCode = (this.vm.userEstonianIdentificationCode || "").trim();
		if (!this.idCodeUtil.isValid(this.vm.userEstonianIdentificationCode)) {
			this.vm.showIdentifierDoesNotValidate = true;
			return;
		}
		if (this.vm.isValidatePatientStep2) {
			if (this.vm.requesterRelationshipToPatient) {
				this.vm.noConnectionDefined = false;
				this.preVisitRecordTicketForPersonService.setRequesterRelationshipToPatient(this.vm.requesterRelationshipToPatient);
				this.angularRoutingHelperService.setPath('/pre-visit');
			} else {
				this.vm.noConnectionDefined = true;
				this.vm.loading = false;
			}
		} else {
			this.vm.loading = true;
			this.searchUserByIdCode(this.vm.userEstonianIdentificationCode)
				.then((response) => {
					if (response.errorCode === 'USER_DOES_NOT_EXIST') {
						this.vm.showCreateUserButton = true;
					} else {
						this.vm.isValidatePatientStep2 = true;
						this.preVisitRecordTicketForPersonService.setPatient(response);
					}
					this.vm.loading = false;
				})
				.catch((error) => {
					if (error.error.errorCode === 'CONSENT_NOT_GIVEN_TO_INSURANCE_DATA') {
						this.vm.isUserConsentsNotGiven = true;
					}
					if (error.error.errorCode === 'NOT_SERVICED_BY_SAME_GP_ORG') {
						this.vm.isInserterAndPatientNotServicedBySameGpOrganization = true;
					}
					if (error.error.errorCode === 'INSURANCE_INFO_NOT_FOUND') {
						this.vm.isInsuranceDataNotFound = true;
					}
					this.vm.loading = false;
					console.log(error);
				});
		}
	}
	
	searchUserByIdCode(userIdentifierCode) {
		return this.restService.getPreVisitInsertForPatientValidateUser({'userIdentifierCode': userIdentifierCode})
	}
	
	showCreateUserModal() {
		var dialog = this.dialogServices.show({
			controller: ModalInsertForPersonCreateUserComponent,
			userEstonianIdentificationCode: this.vm.userEstonianIdentificationCode,
			isPatient: this.vm.isValidatePatientStep1
		});
		dialog.afterClosed().subscribe(
			user => {
				if (user && this.vm.isValidatePatientStep1) {
					this.preVisitRecordTicketForPersonService.setPatient(user);
					this.vm.isValidatePatientStep2 = true;
				}
				this.vm.showCreateUserButton = false;
			},
			() => {
				this.vm.showCreateUserButton = false;
			}
		);
	}
	
	showGiveConsentsModel() {
		var dialog = this.dialogServices.show({
			controller: ModalInsertForPersonGiveConsentsComponent,
			userEstonianIdentificationCode: this.vm.userEstonianIdentificationCode,
			isPatient: this.vm.isValidatePatientStep1
		});
		dialog.afterClosed().subscribe(
			user => {
				this.vm.validatePatientIdentifier();
				this.vm.isUserConsentsNotGiven = false;
			},
			() => {
				this.vm.isUserConsentsNotGiven = true;
			}
		);
	}
	
	cantUseServiceReasonPicker() {
		if (!this.vm.businessService && this.vm.isInsured) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsured && this.vm.businessService && this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['NO_ACTIVE_EHIF_INSURANCE'];
		} else if (!this.vm.isInsured && !this.vm.businessService && this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsured && !this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['NOT_PART_OF_ANY_PATIENT_LISTING'];
		} else if (this.vm.businessService && !this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['DOCTOR_JOINED_BUT_PRE_VISIT_DISABLED'];
		}
		return '';
	}
	
}